import React, { FunctionComponent, useEffect } from "react";
import styles from "./Quote.module.scss";
import QuoteProps from "./QuoteProps.interface";

import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import BubbleBackground from "components/BubbleBackground/BubbleBackground";
import combineClasses from "helpers/combine-classes";
import getWrapperClasses from "blocks/helpers/getWrapperClasses";
import IconViewer from "components/IconViewer/IconViewer";
import useAnchorIdentifier from "hooks/useAnchorIdentifier";
import isBrowserContext from "helpers/isBrowserContext";

const Quote: FunctionComponent<QuoteProps> = (props) => {
    const wrapperClasses = getWrapperClasses(props.settings);
    const identifier = useAnchorIdentifier(props.settings.anchorIdentifier);

    // ANIMATION
    const controls = useAnimation();
    const { ref, inView } = useInView({ threshold: 0.3 });

    const animateUp = {
        visible: { y: 0, opacity: 1 },
        hidden: { y: 80, opacity: 0 }
    };
    const animateDown = {
        visible: { y: 0, opacity: 1 },
        hidden: { y: -80, opacity: 0 }
    };

    const selectAnimation = props.settings.animation && props.settings.animation.length > 0 ? props.settings.animation[0].content._contentType : undefined;
    const selectVariants = selectAnimation === "animateUp" ? animateUp : selectAnimation === "animateDown" ? animateDown : undefined;
    const repeatAnimation = props.settings.animation && props.settings.animation.length > 0 ? props.settings.animation[0].content.repeatAnimation : false;

    useEffect(() => {
        if (inView) {
            controls.start("visible");
        }
        if (!inView && repeatAnimation) {
            controls.start("hidden");
        }
    }, [controls, inView]);

    return (
        <motion.section className={combineClasses([styles.wrapper, ...wrapperClasses])} id={identifier} ref={ref} initial={isBrowserContext() ? "hidden" : "shown"} animate={controls} variants={selectVariants} transition={{ duration: 0.4 }}>
            <div className={styles.container}>
                {props.settings.showIcon ? (
                    <IconViewer className={styles.quote_icon} name="quote" />
                ) : null}

                {props.content.text ? (
                    <div className={styles.text}>
                        {props.content.text}
                    </div>
                ) : null}

                {props.content.author ? (
                    <div className={styles.author_wrapper}>
                        <span className={styles.author}>{props.content.author}</span>

                        {props.content.authorTitle ? (
                            <div>{props.content.authorTitle}</div>
                        ) : null}
                    </div>
                ) : null}
            </div>

            {props.settings.bubbleBackground && props.settings.bubbleBackground.length > 0 ? (
                <BubbleBackground {...props.settings.bubbleBackground[0]} />
            ) : null}
        </motion.section>
    );
};

export default Quote;